'use es6';

import { Map as ImmutableMap, OrderedMap } from 'immutable';
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import { TableVisualization } from 'reporting-visualizations/visualizations/table/tableRecords';
import { getReferenceLabel, getPropertyLabel, getReference } from 'reporting-data/v2/dataset/datasetRecords';
import { CUSTOM_FIELD_KEYS, CUSTOM_FIELD_RENDERS } from './renderUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const FIELD_PROPERTY = '__field';
const transpose = (dataPoints, byProp, propsToKeep) => dataPoints.reduce((collect, point) => point.keySeq().toArray().reduce((innerCollect, key) => propsToKeep.includes(key) ? innerCollect.setIn([key, point.get(byProp)], point.get(key)) : innerCollect, collect), propsToKeep.reduce((collect, prop) => collect.set(prop, ImmutableMap()), OrderedMap())).map((point, prop) => point.set(FIELD_PROPERTY, prop)).toList();
const defaultRenderCell = args => {
  const {
    label,
    column,
    dataset
  } = args;
  const {
    align,
    onClick,
    renderCell
  } = column;
  if (renderCell) {
    return renderCell(Object.assign({}, args, {
      column: ImmutableMap(Object.assign({}, column, {
        dataset
      }))
    }));
  }
  return (
    /*#__PURE__*/
    /*@bend-expect trellis-tokenized */
    _jsx("td", {
      className: align === 'left' ? 'text-left' : 'text-right',
      children: onClick ? /*#__PURE__*/_jsx(Button, {
        onClick: () => onClick(args),
        use: "link",
        children: label
      }) : label
    })
  );
};
const defaultRenderHeaderCell = ({
  label,
  align
}) =>
/*#__PURE__*/
/*@bend-expect trellis-tokenized */
_jsx("th", {
  className: align === 'left' ? 'text-left' : 'text-right',
  children: label
});
export default (({
  data: datasets,
  transpose: {
    field: transposeByField,
    rows,
    rowsByField
  }
}) => {
  const originalDataset = datasets.get('primary');
  const transposedData = transpose(originalDataset.get('data'), transposeByField, rows.map(({
    field
  }) => field)).filter(point => point.get(FIELD_PROPERTY) !== transposeByField);
  const columnValues = originalDataset.get('data').map(dataPoint => dataPoint.get(transposeByField)).toSet().toList().sort();
  const rowInfoMap = rows.reduce((collect, row) => Object.assign({}, collect, {
    [row.field]: row
  }), {});
  const renderCell = props => {
    const {
      field,
      value,
      row
    } = props;
    const label = field === FIELD_PROPERTY ? getReference(originalDataset, rowsByField, value) ? getReferenceLabel(originalDataset, rowsByField, value) : getPropertyLabel(originalDataset, value) : getReferenceLabel(originalDataset, row.get(FIELD_PROPERTY), value);
    const rowInfo = field === FIELD_PROPERTY ? Object.assign({
      align: 'left'
    }, CUSTOM_FIELD_KEYS.includes(value) ? {
      renderCell: CUSTOM_FIELD_RENDERS[value]
    } : {}) : rowInfoMap[row.get(FIELD_PROPERTY)];
    const originalRow = originalDataset.get('data').find(dataPoint => dataPoint.get(transposeByField) === field);
    return defaultRenderCell({
      dataset: originalDataset,
      column: rowInfo,
      row: originalRow,
      label
    });
  };
  const renderHeaderCell = ({
    column
  }) => defaultRenderHeaderCell({
    label: column.get('field') === FIELD_PROPERTY ? getPropertyLabel(originalDataset, rowsByField) || I18n.text('reporting-ui-components.customWidgets.salesAnalytics.metric') : getReferenceLabel(originalDataset, transposeByField, column.get('field')),
    align: column.get('field') === FIELD_PROPERTY ? 'left' : 'right'
  });
  const columns = columnValues.unshift(FIELD_PROPERTY).map(columnValue => ({
    dataset: 'primary',
    field: columnValue,
    renderCell,
    renderHeaderCell
  }));
  return TableVisualization({
    data: datasets.setIn(['primary', 'data'], transposedData),
    columns
  });
});